import { render, staticRenderFns } from "./VideoShow.vue?vue&type=template&id=0277a14c&scoped=true"
import script from "./VideoShow.vue?vue&type=script&lang=js"
export * from "./VideoShow.vue?vue&type=script&lang=js"
import style0 from "./VideoShow.vue?vue&type=style&index=0&id=0277a14c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0277a14c",
  null
  
)

export default component.exports